import React, { useState, useEffect, useRef } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { timesheetApi } from "../../services";
import { Button } from "primereact/button";
import { Fieldset } from "primereact/fieldset";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import moment from "moment";

const LockedTeamTimesheet = ({ userData }) => {
  const dt = useRef(null);
  const [lockedTeamTimesheet, setLockedTeamTimesheet] = useState([]);
  const [lockedDialog, setLockedDialog] = useState(false);
  const [currentLockedRow, setCurrentLockedRow] = useState({});
  const [dateRange, setDateRange] = useState([]);

  let count = 0;
  useEffect(() => {
    if (count == 0) {
      fetchLockedTeamTimesheet();
      count++;
    }
  }, [userData]);

  const dateRangeCalendar = (e) => {
    setDateRange(e.value);
    let param = {};
    param.userId = userData.id;
    param.status = "LOCKED";
    if (e.value[1]) {
      param.startDate = moment(e.value[0]).format("DD-MM-YYYY");
      param.endDate = moment(e.value[1]).format("DD-MM-YYYY");
      timesheetApi.getLockedTeamTimesheet(param).then((resp) => {
        try {
          setLockedTeamTimesheet(resp.data.data);
        } catch (error) {
          // Error handle
        }
      });
    }
    if (e.value[1]) {
      document.getElementsByClassName("p-datepicker")[0].style.display = "none";
    }
  };
  const rowClassPopup = (rowData) => {
    let row = rowData.timesheetProjects.map((item) => item.categories.title);
    if (row.includes('Leave/PH')) {
      return {
        'row-accessories-leave': row
      }
    }
  }

  const projectListBodyTemplate = (rowData) => {
    let proName = [];
    rowData.timesheetProjects.map((el) => {
      proName.push(el.projectDetails.title);
    });
    let proNameUnique = Array.from(new Set(proName));
    return <p>{proNameUnique.join(", ")}</p>;
  };

  const projectBodyTemplate = (rowData) => {
    return rowData.projectDetails ? rowData.projectDetails.title : "";
  };

  const categoryBodyTemplate = (rowData) => {
    return rowData.categories ? rowData.categories.title : "";
  }
  const activityBodyTemplate = (rowData) => {
    return rowData.activities ? rowData.activities.title : "";
  }
  const ChargeableOrNot = (el) => {
    return el?.isBillable ? <span style={{ color: 'green' }}>Chargeable</span> : <span style={{ color: 'red' }}>Non Chargeable</span>;
  };

  const lockedDialogCall = (rowData) => {
    setCurrentLockedRow(rowData);
    setLockedDialog(true);
  }

  const lockedActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" type="button" className="p-button-rounded p-button-secondary" aria-label="View" tooltip="View Timesheet" tooltipOptions={{ position: "top" }} onClick={() => lockedDialogCall(rowData)} />
      </React.Fragment>
    );
  };

  const hoursRoundOffTemplate = (item) => {
    return item.hours?.toFixed(2);
  };

  const LockedManagerViewTemplate = () => {
    return (
      <div className="orders-subtable">
        <Dialog className="review-timesheet-pop-up-dialog custom_popup" header={"View Locked Timesheet (" + currentLockedRow?.date + ")"} visible={lockedDialog} onHide={() => setLockedDialog(false)} >
          <Fieldset>
            <DataTable columnResizeMode="fit" scrollable="horizontal" stripedRows value={currentLockedRow?.timesheetProjects} responsiveLayout="scroll">
              <Column field="id" header="Id"></Column>
              <Column field="" header="Project" body={projectBodyTemplate} style={{ minWidth: "15rem" }}></Column>
              <Column field="categoryId" header="Category" style={{ minWidth: "10rem" }} body={categoryBodyTemplate}></Column>
              <Column field="activityId" header="Activity" style={{ minWidth: "10rem" }} body={activityBodyTemplate}></Column>
              <Column header="Billing Type" body={ChargeableOrNot} style={{ minWidth: "10rem" }}></Column>
              <Column field="" header="Hours" body={hoursRoundOffTemplate}></Column>
              <Column field="jiraTaskId" header="JIRA / Task ID" style={{ minWidth: "10rem" }}></Column>
              <Column field="description" header="Description" style={{ minWidth: "40rem" }}></Column>
            </DataTable>
          </Fieldset>
        </Dialog>
      </div>
    );
  };

  const fetchLockedTeamTimesheet = () => {
    let param = {};
    param.userId = userData.id;
    param.status = "LOCKED";
    param.startDate = "";
    param.endDate = "";
    timesheetApi.getLockedTeamTimesheet(param).then((resp) => {
      try {
        setLockedTeamTimesheet(resp.data.data);
        setDateRange(null);
      } catch (error) {
        // Error handle
      }
    });
  };

  const hoursRoundOff = (item) => {
    return item.totalHours?.toFixed(2);
  };

  return (
    <>
      <div className='grid mb-2'>
        <div className='col-12 mb-1 text-right'>
          <Calendar id="range" value={dateRange} onChange={(e) => dateRangeCalendar(e)} selectionMode="range" readOnlyInput dateFormat="dd-mm-yy" mask="99-99-9999" showIcon placeholder="Select date range" />
        </div>
      </div>
      <div className="datatable-style-demo">
        <DataTable paginator responsiveLayout="scroll" columnResizeMode="fit" scrollable="horizontal" rows={10}
          rowsPerPageOptions={[10, 20, 50]} dataKey="id" stripedRows ref={dt} value={lockedTeamTimesheet}
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" className='row-accessories' rowClassName={rowClassPopup}>
          <Column field="id" header="ID" style={{ minWidth: "8rem" }}></Column>
          <Column field="date" header="Date" style={{ minWidth: "10rem" }}></Column>
          <Column field="" header="Projects" style={{ minWidth: "10rem" }} body={projectListBodyTemplate}></Column>
          <Column field="" header="Total Hours" body={hoursRoundOff} style={{ minWidth: "8rem" }}></Column>
          <Column field="" header="Action" body={lockedActionBodyTemplate} style={{ minWidth: "10rem" }}></Column>
        </DataTable>
      </div>
      {LockedManagerViewTemplate()}
    </>
  );
};

export default LockedTeamTimesheet;